import { writable } from 'svelte/store';

export const criticalWarningsStore = writable({});

export const setCriticalWarning = (key, warning) => {
  criticalWarningsStore.update((warnings) => ({ ...warnings, [key]: warning }));
};

export const removeCriticalWarning = (key) => criticalWarningsStore.update(({ [key]: removedValue, ...otherWarnigns }) => otherWarnigns);
